import { createLcg } from "../rng/lcg.js";
import { weightedPick } from "../rng/weightedPick.js";
import type { LoadEffect } from "../types/index.js";

export type PickLoadInput = {
  loads: readonly LoadEffect[];
  rngState: number;
};

export type PickLoadResult = {
  load: LoadEffect;
  rngState: number;
};

export function pickLoad(input: PickLoadInput): PickLoadResult {
  const rng = createLcg(input.rngState);
  const load = weightedPick(input.loads, rng);
  return { load, rngState: rng.state };
}
